import React, { FC } from 'react';

import InputField from 'src/presentation/components/forms/InputField';
import { Row } from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import {
  NodeProps,
  DESCRIPTION_PLACEHOLDER_TEXT,
  DESCRIPTION_LABEL_TEXT,
} from 'src/presentation/components/pages/ivr/constants/ivrConstants';

const GenericNode: FC<NodeProps> = ({ attr, disabled, readOnly }) => {
  return (
    <>
      <Row>
        <InputField
          attr={`${attr}.name`}
          data-aid="name"
          disabled={disabled}
          label="Name"
          description="The name you can refer to link to other nodes"
          readOnly={true}
        />
      </Row>
      <Row>
        <InputField
          attr={`${attr}.description`}
          data-aid="description"
          disabled={disabled}
          label={DESCRIPTION_LABEL_TEXT}
          placeholder={DESCRIPTION_PLACEHOLDER_TEXT}
          readOnly={readOnly}
        />
      </Row>
    </>
  );
};

export default GenericNode;
